import React, { Component } from 'react';

import { ResponsiveBar } from '@nivo/bar';
import { chartColors } from './chartColors';

// const axisBottom = {
//   "orient": "bottom",
//   "tickSize": 5,
//   "tickPadding": 5,
//   "tickRotation": 0,
//   "legend": "",
//   "legendPosition": "center",
//   "legendOffset": 36
// }

// const axisLeft = {
//   "orient": "left",
//   "tickSize": 5,
//   "tickPadding": 5,
//   "tickRotation": 0,
//   "legend": "",
//   "legendPosition": "center",
//   "legendOffset": -40
// }

const margin = {
  "top": 0,
  "right": 50,
  "bottom": 50,
  "left": 80
}

class SimpleBarGraph extends Component {
  render() {
    return (
      <div style={{width: 100 + '%', height: this.props.height + 'px'}}>
        <ResponsiveBar
          data={this.props.details.data}
          keys={this.props.details.keys}
          indexBy={this.props.details.indexBy}
          margin={this.props.margin || margin}
          padding={0.7}
          groupMode="grouped"
          colors={this.props.colors || chartColors.yellows}
          colorBy="id"
          borderColor="inherit:darker(1.6)"
          //axisBottom={this.props.axisBottom}
          //axisLeft={this.props.axisLeft}
          enableLabel={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor="inherit:darker(1.6)"
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          isInteractive={true}
          tooltip={(id) => {
            return <div>
                    <b>Year: </b> {id.indexValue} 
                    <br/>
                    <b>Return: </b> {id.value + "%"} 
                </div>
          }}
          enableGridX={this.props.enableGridX}
        />
      </div>
    );
  }
}

export default SimpleBarGraph;
